
//react select customizatoin css
export const customStyles = {
    control: (base) => ({
        ...base,
        height: 29,
        minHeight: 29,
        display: 'flex',
        alignItems: 'center',
    }),
    placeholder: (base) => ({
        ...base,
        display: 'flex',
        alignItems: 'center',
        fontSize: '12px',
        fontWeight: "600",
        color: '#808080',
    }),
    menu: (base) => ({
        ...base,
        fontSize: '12px',
    }),
    option: (base) => ({
        ...base,
        fontSize: '12px',
    }),
    singleValue: (base) => ({
        ...base,
        fontSize: '12px',
        display: 'flex', // Ensure singleValue aligns center vertically
        alignItems: 'center',
    }),
};

export const urlMappings = [
    { backend: "http://localhost:4600", frontend: "http://localhost:3000", hrms_url: "https://preflexichain.alobhadev.com" }, 
    { backend: "https://cargodev.alobhatech.com", frontend: "https://cargodev.alobhadev.com", hrms_url: "https://preflexichain.alobhadev.com" }, 
    { backend: "https://ccargoapi.alobhatech.com", frontend: "http://cargotheme.alobhadev.com", hrms_url: "https://preflexichain.alobhadev.com" }, 
    { backend: "https://flexichains.com", frontend: "https://flexichain.co.in", hrms_url: "https://hrms.flexichains.com" }, 
    { backend: "https://committedbackend.flexichains.com", frontend: "https://committedcrms.flexichains.com", hrms_url: "https://committedhrms.flexichains.com" }, 
    { backend: "https://api.flexichains.com", frontend: "https://flexichains.com", hrms_url: "https://hrms.flexichains.com" },
];

const getHrmsUrl = () => {
    const currentUrl = window.location.origin; // Get the current frontend URL
    const mapping = urlMappings.find(entry => entry.frontend === currentUrl);
    return mapping ? mapping.hrms_url : "#"; // Return HRMS URL or '#' if not found
};


// capitalize first letter
export function capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || !string.length) {
        return ''; // Return empty string if input is not a valid string
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}


//DD-MMM-YYYY format Date
export function DDMMMYYYYformateDate(dateString) {
    if (dateString) {
        const date = new Date(dateString);
        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return ""; // Return an empty string if the date is invalid
        }

        const day = String(date.getDate()).padStart(2, "0");
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }
}

export function isExpiringInTwoDays(contractExpiryDate) {
    // Parse contract expiry date
    const expiryDate = new Date(contractExpiryDate);
    const today = new Date();

    // Calculate the difference in time (in milliseconds)
    const timeDifference = expiryDate - today;

    // Convert time difference from milliseconds to days
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    // Return true if the difference is less than 2 days, else false
    return daysDifference < 2;
};

//get date time with AMPM
export function AMPMDATETIME(isoDate) {
    try {
        // Validate and parse the ISO date
        const date = new Date(isoDate);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return ''; // Return an empty string for invalid dates
        }

        // Extract date components
        const day = date.getDate().toString().padStart(2, '0');
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();

        // Extract time components
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';

        // Convert to 12-hour format
        hours = hours % 12 || 12;

        // Combine into the desired format
        return `${day}-${month}-${year}, ${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    } catch (error) {
        // Handle any unexpected errors
        return '';
    }
}
//set date for setting to calender
export const convertInputToCalender = (isoDate) => {
    if (!isoDate) return ""; // Handle undefined/null case
    const date = new Date(isoDate);
    if (isNaN(date)) return ""; // Handle invalid date case

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const formatDateToDDMMYYYY = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};

export const convertDateTimeToApiFormatInJobOrderTransport = (inputDateTime) => {
    if (!inputDateTime) return ''; // Return empty if input is null or undefined

    // Check if the input matches the expected format using regex
    const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
    if (!dateTimeRegex.test(inputDateTime)) {
        return ''; // Return empty for invalid format
    }

    try {
        // Parse the input date and time
        const [datePart, timePart] = inputDateTime.split('T'); // Split by 'T'
        const [year, month, day] = datePart.split('-'); // Extract date components
        const [hour, minute] = timePart.split(':'); // Extract time components

        // Return the formatted date and time
        return `${year}-${month}-${day} ${hour}:${minute}`;
    } catch (error) {
        // Catch any unexpected parsing errors
        return '';
    }
}

// export const convertToDatetimeLocalFormatInJobOrderTransport = (apiDatetime) => {
//     if (typeof apiDatetime !== "string") return ""; // Ensure input is a string

//     // Check if the input matches the expected API format
//     // const datetimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
//     const datetimeRegex = /^\d{4}-\d{1,2}-\d{1,2} \d{2}:\d{2}:\d{2}$/;
//     if (!datetimeRegex.test(apiDatetime)) {
//         console.log("IS done dona done.")
//         return ""; // Return empty string for invalid format
//     }

//     try {
//         // Replace space with 'T' and remove seconds
//         // console.log(apiDatetime.replace(" ", "T").slice(0, 16));
//         return apiDatetime.replace(" ", "T").slice(0, 16);
//     } catch (error) {
//         return ""; // Return empty string if unexpected error occurs
//     }
// }


//convert YYYY-MM-DD to DD-MM-YYYY

export const convertToDatetimeLocalFormatInJobOrderTransport = (apiDatetime) => {
    if (typeof apiDatetime !== "string") return ""; // Ensure input is a string

    // Updated regex to match input format
    const datetimeRegex = /^\d{4}-\d{1,2}-\d{1,2} \d{2}:\d{2}:\d{2}$/;
    if (!datetimeRegex.test(apiDatetime)) {
        console.log("Invalid datetime format.");
        return ""; // Return empty string for invalid format
    }

    try {
        // Split date and time
        const [date, time] = apiDatetime.split(" ");
        let [year, month, day] = date.split("-").map(Number); // Convert to numbers
        const [hours, minutes] = time.split(":").map(Number); // Ignore seconds

        // Zero-pad month, day, and time components
        month = String(month).padStart(2, "0");
        day = String(day).padStart(2, "0");
        const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

        // Construct the formatted datetime string without seconds
        return `${year}-${month}-${day}T${formattedTime}`;
    } catch (error) {
        console.error("Error processing datetime:", error);
        return ""; // Return empty string if an unexpected error occurs
    }
}

export function convertDateYYYYMMDDToDDMMYYYY(dateString) {
    // Validate input format using regex
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateString)) {
        return ""; // Return empty string if input format is invalid
    }

    try {
        // Split the input date into components
        const [year, month, day] = dateString.split("-");
        // Rearrange the components into DD-MM-YYYY format
        return `${day}-${month}-${year}`;
    } catch (error) {
        return ""; // Return empty string if an unexpected error occurs
    }
}



export function limitString(inputString, maxLength) {
    // If inputString length is less than or equal to maxLength, return the whole string
    if (!maxLength) {
        maxLength = 30
    }
    if (inputString.length <= maxLength) {
        return inputString;
    }

    // If inputString is longer, truncate and add "..."
    const truncatedLength = maxLength - 3; // Reserve space for "..."
    return inputString.substring(0, truncatedLength) + "...";
}



//Custom clearance job order functions:

// "2024-12-28T19:39" date format into  "2024-12-28 19:39"
export function convertDateTimeToAPIFormatInCustomClearanceJobOrder(dateString) {
    // Regular expression to match the correct format: YYYY-MM-DDTHH:mm
    const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

    // Check if the input matches the format
    if (validFormat.test(dateString)) {
        // Replace 'T' with a space if the format is correct
        return dateString.replace('T', ' ');
    }

    // Return an empty string if the format is incorrect
    return '';
}


export function setDateTimeOnCalenderCCExportJobOrder(isoDate) {
    try {
        // Parse the ISO date into a JavaScript Date object
        const date = new Date(isoDate);

        if (isNaN(date.getTime())) {
            // Return an empty string if the date is invalid
            return '';
        }

        // Extract the components and format them as required
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Combine the components into the required format
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch (error) {
        // Return an empty string if any error occurs
        return '';
    }
}


export function setDateTimeOnCalenderCCImportJobOrder(isoDate) {
    try {
        // Parse the ISO date into a JavaScript Date object
        const date = new Date(isoDate);

        if (isNaN(date.getTime())) {
            // Return an empty string if the date is invalid
            return '';
        }

        // Extract the components and format them as required
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Combine the components into the required format
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch (error) {
        // Return an empty string if any error occurs
        return '';
    }
}



///freight forwarding 
export function convertYYYY_MM_DDtoDD_MMM_YYYYformat(input) {
    try {
        // Validate the format using regex
        const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        if (!datePattern.test(input)) {
            return '';
        }

        // Parse the date
        const [year, month, day] = input.split('-');
        const date = new Date(`${year}-${month}-${day}`);

        // Check if the parsed date is valid
        if (isNaN(date.getTime())) {
            return '';
        }

        // Format the date
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${day}-${monthNames[parseInt(month, 10) - 1]}-${year}`;
    } catch (error) {
        // Handle unexpected errors
        return '';
    }
}


export function convertYYYY_MM_DDTHH_MM_SS_MMSZ_to_DD_MM_YYYY(dateString) {
    // Check if the input is a valid date
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return ""; // Return empty string if the input is not a valid date
    }
  
    // Define the months in the desired format
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
    // Extract day, month, and year
    const day = date.getDate().toString().padStart(2, "0"); // Ensure 2-digit day
    const month = months[date.getMonth()]; // Get month name
    const year = date.getFullYear(); // Get year
  
    // Return the formatted date
    return `${day}-${month}-${year}`;
  }
  